/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */

export type AssociationRole = typeof AssociationRole[keyof typeof AssociationRole];


export const AssociationRole = {
  ADMIN: 'ADMIN',
  MANAGE_USERS: 'MANAGE_USERS',
  MEMBER: 'MEMBER',
} as const;
